import * as ClientSideDiagnostics from "./Diagnostics/ClientSideDiagnostics";
import * as ServerHealthDiagnostics from "./Diagnostics/ServiceHealthDiagnostics";
import * as StorageDiagnostics from "./Diagnostics/StorageDiagnostics";
import * as BrowserDetector from "./Diagnostics/BrowserDetector";
import * as ManifestHelper from "./Diagnostics/ManifestDiagnostics";
import * as iFrameHelper from "./Diagnostics/iFrameDiagnostics";
import * as AuthHelper from "./Diagnostics/AuthDiagnostics";
import * as DomHelper from "./Helpers/DomHelper";
import * as WebWorkerHelper from "./Diagnostics/WebWorker";
import * as ValuePersistenceDiagnostics from "./Diagnostics/ValuePersistenceDiagnostics";
import { resetAllBlobData, resetPartialBlobData } from "./Helpers/BlobHelper";
import { setCancelDiagnosticsStatus, cancel } from "./Helpers/ExecutionStatus";
/** boolean indicating whether we are running in a local environment */
const global = window;
const { selfHelp: { runAuthDiagnostics } } = global;
/**
 * This function resets all the data from previous tests so that the test can run
 * multiple times to get new results without page refresh.
 */
function reInitializePage() {
    // indicates this is the second time running all tests
    if (cancel !== null) {
        resetAllBlobData();
    }
    setCancelDiagnosticsStatus(false);
    DomHelper.startAllTestDisplayUpdate();
}
/** Starts all possible diagnostic tests */
function startDiagnosticTests() {
    if (runAuthDiagnostics) {
        AuthHelper.startTest();
    }
    /*  Hosting service diagnostics will now happen within ClientSideDiagnostics.
        Pinging hosting services for all unique extensions is not necessary to determine
        if there is a hosting service problem.
    if (runAfdDiagnostics) {
        HostingServiceDiagnostics.startTest();
    }
    */
    WebWorkerHelper.startTest();
    ServerHealthDiagnostics.startTest();
    ManifestHelper.startTest();
    StorageDiagnostics.startTest("sessionStorage");
    StorageDiagnostics.startTest("localStorage");
    iFrameHelper.startTest();
    BrowserDetector.startTest();
    ValuePersistenceDiagnostics.startTest("cookiePersistence");
    ValuePersistenceDiagnostics.startTest("requestBodyPersistence");
    ClientSideDiagnostics.startTest();
}
/** Determines which diagnostic test button was clicked to rerun and starts the appropriate test. */
function determineTest(taskId) {
    switch (taskId) {
        case "clientSideDependencyEndpoints":
            ClientSideDiagnostics.startTest();
            break;
        case "serviceHealthEndpoints":
            ServerHealthDiagnostics.startTest();
            break;
        case "fetchManifest":
            ManifestHelper.startTest();
            break;
        case "sessionStorage":
            StorageDiagnostics.startTest("sessionStorage");
            break;
        case "localStorage":
            StorageDiagnostics.startTest("localStorage");
            break;
        case "loadIFrame":
            iFrameHelper.startTest();
            break;
        case "authToken":
            AuthHelper.startTest();
            break;
        case "webWorkers":
            WebWorkerHelper.startTest();
            break;
        case "cookiePersistence":
            ValuePersistenceDiagnostics.startTest("cookiePersistence");
            break;
        case "requestBodyPersistence":
            ValuePersistenceDiagnostics.startTest("requestBodyPersistence");
            break;
    }
}
/** Resets display, blob, and cancel status, for individual task running */
export function runIndividualTask(taskId) {
    DomHelper.startTaskDisplayUpdate(taskId);
    resetPartialBlobData(taskId);
    setCancelDiagnosticsStatus(false);
    determineTest(taskId);
}
/** Calls helper functions to reset page data, initialize the view, and start tests. */
export function start() {
    reInitializePage();
    startDiagnosticTests();
}
/** Handles the DOM update and "cancel status" if test are cancelled */
export function cancelTests() {
    setCancelDiagnosticsStatus(true);
    DomHelper.endTestDisplayUpdate();
    DomHelper.handleCancelledTests();
}
//# sourceMappingURL=SelfHelp.js.map